module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		resourceConnected: false
	},

	methods: {
		dataDealer: function(){
			var self = this;
			this.closest('base_mediaManagement_imageAssignmentDetails_imageAssignmentDetails', function(imageAssignmentDetailsComponent){
				if(imageAssignmentDetailsComponent.resourceData && imageAssignmentDetailsComponent.resourceData.data){
					self.resourceData = {
						data: imageAssignmentDetailsComponent.resourceData.data
					};
				}
			});
		},

		onChange: function(){
			var self = this;
			this.closest('base_mediaManagement_imageAssignmentDetails_imageAssignmentDetails', function(imageAssignmentDetailsComponent){
				imageAssignmentDetailsComponent.onChange(self.model.dirtyFields);
			});
		}
	}
};
